<script setup>
import { ref, onMounted } from 'vue'
import { useCookie } from '@/@core/composable/useCookie'
import { useDisplay } from 'vuetify'

const { mdAndUp, mobile } = useDisplay()
const deferredPrompt = ref(null)
const showInstallPrompt = ref(false)
const dontShowInstallPromptAgain = ref(false)

const isDesktop = computed(() => mdAndUp.value) // 960px and above
const isMobile = computed(() => mobile.value) // Below 600px
const isTablet = computed(() => !isDesktop.value && !isMobile.value) // Between 600px

const setDontShowInstallPromptAgain = () => {
  if (dontShowInstallPromptAgain.value)
    useCookie('dontShowInstallPromptAgain').value = true
}

const installPWA = async () => {

  setDontShowInstallPromptAgain()

  if (deferredPrompt.value) {

    deferredPrompt.value.prompt()

    const { outcome } = await deferredPrompt.value.userChoice
    if (outcome === 'accepted') {
      useCookie('dontShowInstallPromptAgain').value = true
      dismissPrompt()
    }
  }
}

const dismissPrompt = () => {

  setDontShowInstallPromptAgain()

  showInstallPrompt.value = false
  deferredPrompt.value = null
  window.removeEventListener('beforeinstallprompt')
}

onMounted(() => {

  if (useCookie('dontShowInstallPromptAgain').value || isDesktop.value)
    return

  window.addEventListener('beforeinstallprompt', (e) => {
    if (deferredPrompt.value) {
      dismissPrompt()
    }
    else {
      e.preventDefault()
      deferredPrompt.value = e
      showInstallPrompt.value = true
    }
  })
})

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt')
})
</script>

<template>
  <VDialog max-width="500" :model-value="showInstallPrompt">
    <!-- 👉 Dialog close btn -->
    <DialogCloseBtn @click="dismissPrompt" />
    <VCard class="text-center px-10 py-6">
      <VCardText>
        <p>{{ $t('Install this app for better experience') }}</p>

      </VCardText>
      <div class="d-flex justify-end gap-3 flex-wrap">
        <VBtn @click="installPWA" color="primary">{{ $t('Install App') }}</VBtn>
        <VBtn @click="dismissPrompt" color="error">{{ $t('Cancel') }}</VBtn>
      </div>
      <br />
      <VCheckbox :label="$t('Dont show this again')" v-model="dontShowInstallPromptAgain" />
    </VCard>
  </VDialog>

</template>

<style scoped>
.install-banner {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 1rem;
  background: #42b983;
  color: white;
  border-radius: 8px;
  z-index: 1000;
}
</style>
